import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { getImportPaneCloseLocalTaskIds } from '~/components/Import/getImportPaneCloseLocalTaskIds';
import { removeTasksAction } from '~/store/tasks/actions';
import { type ImporterTask } from '~/store/tasks/types';

export type UseImportPaneDismissLocalTasksParams = {
  localTasks: ImporterTask[];
};

/** Removes completed/errored local importer tasks when an import pane closes (pre-ui2026 or ui2026 tray). */
export const useImportPaneDismissLocalTasks = ({ localTasks }: UseImportPaneDismissLocalTasksParams) => {
  const dispatch = useDispatch();

  const dismissCompletedAndErroredLocalImportTasks = useCallback(() => {
    const taskIds = getImportPaneCloseLocalTaskIds(localTasks);

    if (taskIds.length > 0) {
      dispatch(removeTasksAction({ taskIds }));
    }
  }, [dispatch, localTasks]);

  return { dismissCompletedAndErroredLocalImportTasks };
};
